// noinspection JSUnusedGlobalSymbols

export enum  Gender {
  male = 'm',
  female = 'f',
  other= 'o'
}

export enum GenderCaption {
  m = 'Male',
  f = 'Female',
  o = 'Other'
}

export const GenderTitle = {
  m: 'Male',
  f: 'Female',
  o: 'Other'
}

export enum SignupStatus {
  pending = 'SignupPending',
  completed = 'SignupCompleted',
  expired = 'SignupExpired'
}

export enum AccountTypes {
  admin = 'admin',
  bizAdmin = 'bizAdmin',
  staff = 'staff',
  user = 'user',
  student = 'student',
  guest = 'guest'
}

export enum UserStatus {
  activationPending = 'ActivationPending',
  active = 'Active',
  temporarilyBanned = 'TemporarilyBanned',
  banned = 'Banned',
  disabled = 'Disabled'
}

export enum ConsentTypes {
  signUpData = 'signUpData',
  tAndC = 'tAndC',
  privacyPolicy = 'privacyPolicy',
  entityOwnership = 'entityOwnership',
  contentRating = 'contentRating'
}

export enum ConsentActions {
  accepted = 'accepted',
  declined = 'declined'
}

export enum WorkflowStatus {
  pending = 'pending',
  completed = 'completed'
}

export enum WorkflowActions {
  userActivation = 'userActivation',
  changePassword = 'changePassword'
}

export enum UserPresence {
  online = 'Online',
  offline = 'Offline',
  away = 'Away',
  busy = 'Busy',
  unseen = 'Unseen'
}

export const UserPresenceList = [
  {
    icon: 'fa-dot-circle',
    color: '#8EF59F',
    value: UserPresence.online
  },
  {
    icon: 'fa-dot-circle',
    color: '#FF7E7E',
    value: UserPresence.offline
  },
  {
    icon: 'fa-user-times',
    color: '#FF449F',
    value: UserPresence.away
  },
  {
    icon: 'fa-user-clock',
    color: '#FFB400',
    value: UserPresence.busy
  },
  {
    icon: 'fa-eye-slash',
    color: '#BDBDBD',
    value: UserPresence.unseen
  }
];
